module.exports = __webpack_public_path__ + "img/urs_luchinger.cb44a920.png";